import { useState } from "react";
import {
  Box,
  Typography,
  Divider,
  CircularProgress,
  Grid,
} from "@mui/material";
import { FONT_SIZE_LARGE } from "../constants/appConstants";
import TextButton from "./button";
import { Colors } from "../config/default";
import ScrollbarStyles from "./customScroll";
import { CallSummary } from "../services/services";
import { formatDateCall } from "../common";

export default function CallHistory({ callDetails }) {
  const [showTranscript, setShowTranscript] = useState(false);
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(false);

  const getCallSummary = async (sentencesArray) => {
    setLoading(true);
    const payload = {
      transcriptText: sentencesArray
        ? sentencesArray?.map((item) => item?.transcript).join(" ")
        : "",
    };
    const res = await CallSummary(payload);
    if (res?.status === 200) {
      setSummary(res?.data?.data);
    }
    setLoading(false);
  };

  const toggleTranscript = () => {
    setShowTranscript(!showTranscript);
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "white",
        borderRadius: 2,
        mb: 3,
        overflow: "hidden",
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            mb: "10px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Nunito",
              fontSize: FONT_SIZE_LARGE,
              fontWeight: "600",
            }}
          >
            Call Details
          </Typography>
          <Typography sx={{ fontFamily: "Nunito", fontSize: FONT_SIZE_LARGE }}>
            {formatDateCall(callDetails?.createdAt) || "-"}
          </Typography>
        </Box>
        <Typography sx={{ fontFamily: "Nunito", fontSize: FONT_SIZE_LARGE }}>
          From: {callDetails?.callFrom}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Nunito",
            fontSize: FONT_SIZE_LARGE,
            mt: "10px",
          }}
        >
          To: {callDetails?.callTo[0] || "--"}
        </Typography>
        <Typography
          sx={{ fontFamily: "Nunito", fontSize: FONT_SIZE_LARGE, mt: "10px" }}
        >
          Caller Name: {callDetails?.callerName || "--"}
        </Typography>
        <Divider sx={{ m: "10px 0px" }} />
        <Typography
          sx={{
            fontSize: FONT_SIZE_LARGE,
            fontFamily: "Nunito",
            fontWeight: "600",
            mb: "10px",
          }}
        >
          Recordings And Transcripts
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: "81%",
              backgroundColor: "#F1F3F4",
              borderRadius: "10px",
              border: "1px solid lightgrey",
            }}
          >
            <audio controls style={{ width: "100%" }}>
              <source src={callDetails?.recordingUrl} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </Box>
          <TextButton
            buttonText={showTranscript ? "Hide Summary" : "View Summary"}
            height="2rem"
            width="18%"
            backgroundColor={Colors.SKY_BLUE}
            hoverColor={Colors.SKY_BLUE}
            onClick={() => {
              toggleTranscript();
              if (!showTranscript) {
                getCallSummary(callDetails?.transcription);
              }
            }}
          />
        </Box>
        <Divider sx={{ m: "10px 0px" }} />
        {showTranscript && (
          <>
            <Box
              sx={{
                maxHeight: "15rem",
                overflowY: "auto",
                ...ScrollbarStyles,
                backgroundColor: "#f9f9f9",
                p: "10px",
                borderRadius: 2,
              }}
            >
              <Divider sx={{ m: "10px 0px" }} />
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: 600,
                  fontSize: FONT_SIZE_LARGE,
                  mb: 2,
                }}
              >
                Transcript:
              </Typography>
              {callDetails?.transcription?.map((line, idx) => (
                <>
                  <Typography
                    key={idx}
                    sx={{
                      fontFamily: "Nunito",
                      fontWeight: 600,
                      fontSize: FONT_SIZE_LARGE,
                    }}
                  >
                    {line?.media_channel === 1
                      ? callDetails?.callerName || "Caller"
                      : "Receiver"}
                    :
                  </Typography>

                  <Typography
                    key={idx}
                    sx={{
                      mb: 2,
                      fontFamily: "Nunito",
                      fontSize: FONT_SIZE_LARGE,
                    }}
                  >
                    {line?.transcript}
                  </Typography>
                </>
              ))}
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: 600,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                Summary:
              </Typography>
              {loading ? (
                <Grid
                  container
                  xs={12}
                  sx={{ justifyContent: "center", alignItems: "center" }}
                >
                  <CircularProgress size={20} sx={{ color: Colors.SKY_BLUE }} />
                </Grid>
              ) : (
                <>
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      sx={{
                        fontFamily: "Nunito",
                        fontSize: FONT_SIZE_LARGE,
                      }}
                    >
                      {summary}
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
